import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import { MessageCircle } from 'lucide-react'

export default function ReplyIcon({ contextStyles, className, size = 16 }) {
    return (
        <div className={cn(styles.icon, styles.replyIcon, contextStyles, className)}>
            <MessageCircle size={size} />
        </div>
    )
}
